import ScrollModal from "@/components/common/scroll-modal";
import { Heading, Button } from "@elaniintc/goes-design-system";

interface ActivateTemplateModalProps {
  open: boolean;
  onClose: () => void;
  onActivate: () => void;
  isLoading?: boolean;
}

export default function ActivateTemplateModal({
  open,
  onClose,
  onActivate,
  isLoading = false,
}: ActivateTemplateModalProps) {
  return (
    <ScrollModal
      isOpen={open}
      onClose={onClose}
      title="Activar plantilla"
      description="¿Estás seguro de que deseas activar la plantilla? Se mostrará de la vista principal y podrás usar sus datos."
      srOnlyDescription={false}
      modalContentClassName="w-full max-w-[520px] max-h-[680px] flex flex-col p-6 pt-0"
    >
      <div className="flex py-8 justify-center flex-col items-center">
        <Heading variant="h2" className="!mb-0">
          Activar plantilla
        </Heading>
        <p className="text-center text-body font-normal leading-3xl">
          ¿Estás seguro de que deseas activar la plantilla? Se mostrará en la
          vista principal y podrás usar sus datos.
        </p>
      </div>
      <div className="w-full grid grid-cols-1 tablet:grid-cols-2 py-3 gap-3">
        <Button
          variant="tertiary"
          size="lg"
          type="button"
          disabled={false}
          onClick={onClose}
          className="min-w-[120px] cursor-pointer"
        >
          Cancelar
        </Button>
        <Button
          variant="default"
          size="lg"
          type="submit"
          disabled={false}
          className="min-w-[140px] cursor-pointer disabled:bg-neutral-object-accent disabled:text-on-disabled disabled:border-none disabled:shadow-none"
          onClick={onActivate}
          isLoading={isLoading}
        >
          Activar
        </Button>
      </div>
    </ScrollModal>
  );
}
